<template>
  <div
    class="modal"
    :data-zindex="zIndex"
    :class="{ 'modal-visible': !dialogVisible }"
  >
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :width="width"
      :top="top"
      :modal="false"
      :close-on-click-modal="false"
      :before-close="changedialogVisible"
      :custom-class="isFullScreen ? 'my-dialog' : ''"
    >
      <div
        slot="title"
        class="dialog-header"
        style="display: flex;justify-content: space-between;"
      >
        <div class="title">
          <slot name="title">
            <span>{{ title }}</span>
            <!-- <span class="title">这是一个弹窗</span> -->
          </slot>
        </div>
        <div class="opearate" v-if="showFullScreen">
          <span style="margin-right:30px" @click="isFullScreen = !isFullScreen">
            <svg-icon
              class-name="icon-color"
              :icon-class="!isFullScreen ? 'fullscreen' : 'exit-fullscreen'"
            />
          </span>
        </div>
      </div>
      <slot style="background-color:#fff;"></slot>
      <div slot="footer" class="dialog-footer" style="background-color:#fff;">
        <slot name="footer-cancel">
          <el-button @click="changedialogVisible">取 消</el-button>
        </slot>
        <slot name="footer-confirm">
          <!-- <el-button type="primary" @click="changedialogVisible"
            >确 定</el-button
          > -->
          <el-button type="primary" @click="handleConfirm"
            >确 定</el-button
          >
        </slot>
      </div>
    </el-dialog>
    <div class="after" :style="{ zIndex: zIndex - 1 }"></div>
  </div>

  <!-- <div>
    <slot>666</slot>
  </div> -->
</template>
<script>
// import elDragDialog from "@/directive/el-drag-dialog";
export default {
  data() {
    return {
      isFullScreen: false,
      zIndex: 1000,
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    showFullScreen: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "30%",
    },
    // 如果为嵌套的dialog建议设为true,否则层级不明显
    toBody: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "弹窗",
    },
    top: {
      type: String,
      default: "15vh",
    },
  },
  // directives: {
  //   inner: {
  //     // 指令的定义
  //     // update: function(el, binding, vnode) {
  //     //   const { toBody, dialogVisible } = binding.value;
  //     //   if (toBody && dialogVisible) {
  //     //     vnode.context.zIndex = el.firstChild.style.zIndex;
  //     //     console.log("update");
  //     //     console.log(el.firstChild.style.zIndex + "-----");
  //     //   }
  //     // }
  //     componentUpdated: function(el, binding, vnode) {
  //        const { toBody, dialogVisible } = binding.value;
  //       if (toBody && dialogVisible) {
  //         vnode.context.zIndex = el.style.zIndex;
  //         console.log("update");
  //         console.log(el.style.zIndex + "-----");
  //         console.log(vnode.context.zIndex)
  //       }
  //       // if (binding.toBody && binding.dialogVisible) {
  //       //   vnode.context.zIndex = el.firstChild.style.zIndex
  //       // }
  //     }
  //   }
  // },

  updated() {
    if (this.toBody && this.dialogVisible) {
      const zIndex = this.$el.firstChild.style.zIndex;
      this.zIndex != zIndex && (this.zIndex = zIndex);
    }
  },
  methods: {
    changedialogVisible() {
      // this.dialogVisible=false
      this.$emit("update:dialogVisible", false); //在父组件中事件的监听以.sync语法糖替代
      this.$emit("cancle")
    },
    handleConfirm(){
      this.$emit("confirm")
    }
  },
};
</script>
<style lang="scss">
.modal {
  .el-dialog__wrapper {
    overflow: hidden;
    // opacity: 0.5;
    // background: #000000;
    position: absolute;
    // .dialog-header {
    //   display: flex;
    //   justify-content: space-between;
    // }
    .my-dialog {
      min-height: calc(100vh - 84px);
      // max-height: 500px;
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100% !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      // max-height: 90%;
    }
    .el-dialog__body {
      overflow: auto;
      max-height: 500px;
    }
  }
  .after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.5;
    background: #000000;
    content: "";
    // z-index: 1000;
  }
  // &:after {
  //   position: absolute;
  //   top: 0;
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  //   opacity: 0.5;
  //   background: #000000;
  //   content: "";
  //   z-index: attr(data-zindex);
  //   // z-index: 1000;
  // }
}
.icon-color {
  color: #96989a;
}
.modal-visible {
  display: none;
}
// .modal:after {
//   position: absolute;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   opacity: 0.5;
//   background: #000000;
//   content: "";
//   z-index: 1000;

//   //  height: 100%;
// }
</style>
